// components/Sender/SenderFinishedModal.js
import React from "react";

const STATUS_CFG = {
  finished: { label: "✅ Завершено",  color: "#16a34a", bg: "#dcfce7" },
  stopped:  { label: "⏹ Остановлено", color: "#b45309", bg: "#fef3c7" },
  error:    { label: "✖ Ошибка",       color: "#b91c1c", bg: "#fee2e2" },
};

export function SenderFinishedModal({ info, onClose }) {
  if (!info) return null;
  const { stats = {}, status = "finished", test_run } = info;
  const cfg = STATUS_CFG[status] || STATUS_CFG.finished;

  const rows = [
    ["📤 Отправлено",      stats.sent     ?? 0, "#16a34a"],
    ["🧪 Тестовых",        stats.test     ?? 0, "#f59e0b"],
    ["❌ Failed",          stats.failed   ?? 0, "#dc2626"],
    ["❓ Unknown",         stats.unknown  ?? 0, "#a855f7"],
    ["⏭ Skipped",          stats.skipped  ?? 0, "#6b7280"],
  ];

  const disabled = stats.disabled || [];

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.7)",
      backdropFilter: "blur(4px)", zIndex: 1300,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "#fff", borderRadius: 14, width: "100%",
        maxWidth: 620, maxHeight: "90vh", display: "flex",
        flexDirection: "column", overflow: "hidden",
      }}>
        <div style={{ padding: "18px 22px",
                      background: cfg.bg, borderBottom: "1px solid #e5e7eb" }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: cfg.color }}>
            {cfg.label}
            {test_run && <span style={{ marginLeft: 10, fontSize: 13 }}>🧪 TEST RUN</span>}
          </div>
          {info.finished_at && (
            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
              {new Date(info.finished_at).toLocaleString("ru-RU")}
            </div>
          )}
        </div>

        <div style={{ flex: 1, overflow: "auto", padding: "16px 22px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {rows.map(([lab, val, color]) => (
              <div key={lab} style={{
                display: "flex", justifyContent: "space-between",
                padding: "8px 12px", background: "#f9fafb",
                borderRadius: 8, fontSize: 14,
              }}>
                <span style={{ color: "#374151" }}>{lab}</span>
                <span style={{ fontWeight: 700, color, fontSize: 16 }}>
                  {typeof val === "number" ? val.toLocaleString("ru-RU") : val}
                </span>
              </div>
            ))}
          </div>

          {disabled.length > 0 && (
            <div style={{ marginTop: 18 }}>
              <div style={{ fontWeight: 700, color: "#b91c1c",
                            marginBottom: 8, fontSize: 14 }}>
                ⛔ Отключённые воркеры ({disabled.length})
              </div>
              {disabled.map((d, i) => (
                <div key={i} style={{
                  padding: "8px 12px", background: "#fef2f2",
                  border: "1px solid #fecaca", borderRadius: 8,
                  marginBottom: 6, fontSize: 12,
                }}>
                  <div style={{ fontWeight: 700, color: "#991b1b" }}>
                    {d.worker}
                  </div>
                  <div style={{ color: "#7f1d1d", marginTop: 2,
                                fontFamily: "Consolas, monospace",
                                wordBreak: "break-word" }}>
                    {d.reason}
                  </div>
                </div>
              ))}
            </div>
          )}

          {status === "error" && info.error && (
            <div style={{
              marginTop: 18, padding: 12,
              background: "#fef2f2", color: "#991b1b",
              borderRadius: 8, fontSize: 13,
              fontFamily: "Consolas, monospace",
              wordBreak: "break-word",
            }}>
              {info.error}
            </div>
          )}
        </div>

        <div style={{ padding: "12px 22px", borderTop: "1.5px solid #e5e7eb",
                      display: "flex", justifyContent: "flex-end" }}>
          <button className="btn-primary" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
}